import React from 'react'

const Header = () => {
    return (
        <div>
            <header>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="navbar">
                                <a className="navbar-brand p-0" href=""><img src="/assets/images/world-invite-logo.png" alt="Logo" /></a>
                                <a className="navbar-brand p-0" href=""><img src="/assets/images/ipl-logo.png" alt="Logo" /></a>
                                <a className="navbar-brand p-0" href=""><img src="/assets/images/sel-logo.png" alt="Logo" /></a>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Header